import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import Moon from "../packages/Moon";
import GridItem from "components/GridItem";
import Typography from "@material-ui/core/Typography";

const styles = {
	root: {
		height: "calc(100% - 38px)",
		width: "100%",
		flexDirection: "row",
		flexWrap: "nowrap",
		alignItems: "center",
		justifyContent: "space-evenly"
	},
	gridItemBox: {
		width: "100%",
		height: "400px",
		padding: "10px"
	}
};

const classes = StyleSheet.create({
	noResultsButton: {
		width: "100%"
	},
	titleDiv: {
		display: "flex",
		justifyContent: "start",
		alignItems: "center",
		height: "48px",
		padding: "20px"
	}
});

class VisitedItem extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			lastVisitedItem: Moon.use(null)
		};

		this.dragElement = null;
		this.onMoveOnce = false;
	}

	componentWillMount() {
		Moon.addStar(this);
	}

	render() {
		if (this.props.open == false) return null;
		if (this.state.lastVisitedItem == null)
			return (
				<div style={styles.root}>
					<Button
						classes={{
							root: css(classes.noResultsButton)
						}}
					>
						{" "}
						Hover on item to see it here
					</Button>
				</div>
			);
		let lastVistedItem = Object.assign({}, this.state.lastVisitedItem);
		lastVistedItem["gridName"] = "VisitedItem";
		return (
			<div style={styles.root}>
				<div className={css(classes.titleDiv)}>
					<Typography
						classes={{ root: css(classes.titleText) }}
						variant="body1"
					>
						Last visited item
					</Typography>
				</div>
				<div style={styles.gridItemBox}>
					<GridItem
						item={lastVistedItem}
						selectableItems={false}
						showSort={false}
					/>
				</div>
			</div>
		);
	}
}

export default VisitedItem;
